import React from "react";
import { expertiseCards } from "../mock";
import { ArrowUpRight } from "lucide-react";

export default function Expertise() {
  return (
    <section id="expertise" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div>
            <div className="section-label mb-4">Our Expertise</div>
            <h2 className="font-display text-3xl md:text-5xl font-bold text-gray-900 spaced-heading leading-tight">
              Specialized <span className="text-brand">Talent Solutions</span>
            </h2>
          </div>
          <p className="text-gray-600 max-w-md">A holistic portfolio built around HR, IT, corporate training, and BPO operations.</p>
        </div>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {expertiseCards.map((c) => (
            <div key={c.id} className="card-hover group relative overflow-hidden rounded-2xl bg-white border border-gray-100 aspect-[4/5]">
              <img src={c.image} alt={c.title} className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent" />
              <div className="absolute top-4 left-4 bg-white/95 text-brand text-[10px] font-bold uppercase tracking-widest px-3 py-1 rounded-full">{c.tag}</div>
              <div className="absolute inset-x-5 bottom-5 flex items-end justify-between">
                <h3 className="font-display text-xl font-bold text-white leading-tight max-w-[80%]">{c.title}</h3>
                <div className="w-11 h-11 rounded-full bg-white text-brand flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                  <ArrowUpRight size={18} />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
